module.exports = __webpack_public_path__ + "img/logo-herbario-tefh.d697b82e.png";